import React from "react";

const defaultLabel = (q) => { const [y, t] = q.split("-T"); return `${t}${t === "1" ? "er" : "e"} trimestre ${y}`; };

// Trimestres IRL groupés par année (le plus récent en premier).
export const IrlOptions = ({ table, label = defaultLabel }) => {
  const years = [];
  table.forEach((t) => {
    const y = t.quarter.slice(0, 4);
    if (!years.length || years[years.length - 1].y !== y) years.push({ y, items: [] });
    years[years.length - 1].items.push(t);
  });
  return years.map(({ y, items }) => (
    <optgroup key={y} label={y}>
      {items.map((t) => <option key={t.quarter} value={t.quarter}>{`${label(t.quarter)} · ${String(t.value).replace(".", ",")}`}</option>)}
    </optgroup>
  ));
};
